/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaoBaoProductVo } from './TaoBaoProductVo';
import {
    TaoBaoProductVoFromJSON,
    TaoBaoProductVoFromJSONTyped,
    TaoBaoProductVoToJSON,
    TaoBaoProductVoToJSONTyped,
} from './TaoBaoProductVo';

/**
 * 
 * @export
 * @interface ResponseTaoBaoProductVo
 */
export interface ResponseTaoBaoProductVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseTaoBaoProductVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseTaoBaoProductVo
     */
    message?: string;
    /**
     * 
     * @type {TaoBaoProductVo}
     * @memberof ResponseTaoBaoProductVo
     */
    data?: TaoBaoProductVo;
}

/**
 * Check if a given object implements the ResponseTaoBaoProductVo interface.
 */
export function instanceOfResponseTaoBaoProductVo(value: object): value is ResponseTaoBaoProductVo {
    return true;
}

export function ResponseTaoBaoProductVoFromJSON(json: any): ResponseTaoBaoProductVo {
    return ResponseTaoBaoProductVoFromJSONTyped(json, false);
}

export function ResponseTaoBaoProductVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseTaoBaoProductVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : TaoBaoProductVoFromJSON(json['data']),
    };
}

export function ResponseTaoBaoProductVoToJSON(json: any): ResponseTaoBaoProductVo {
    return ResponseTaoBaoProductVoToJSONTyped(json, false);
}

export function ResponseTaoBaoProductVoToJSONTyped(value?: ResponseTaoBaoProductVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': TaoBaoProductVoToJSON(value['data']),
    };
}

